export class PlaceOrderRequest {

    constructor(handler) {
        this.handler = handler;
    }

    /**
     * Build request
     * @todo: Integrate new options request.
     * @return {{bookings: {}}}
     */
    buildRequest()
    {
        const self = this;

        const request = {
            bookings: {},
        };

        const $tourItems = this.handler.$stepsWrapper.find(`[data-tour-item]`);

        /**
         * Fill guests array
         */
        $tourItems.each(function() {
            const $tourItem = $(this);
            const tourId = $tourItem.data('tour-item');

            // cache items data
            const requestedData = self.handler.items[tourId];

            // arrays containing guests information
            const adults = [];
            const children = [];

            /**
             * Fill adults array
             */
            $tourItem.find('.checkout__guest-info_tour__adult').each(function(){
                const name = $(this).find('.name-input').val();
                adults.push({
                    full_name: name,
                });
            });

            /**
             * Fill children array
             */
            $tourItem.find('.checkout__guest-info_tour__child').each(function(){
                const name = $(this).find('.name-input').val();
                const age = $(this).find('.select-zone__select').val();

                children.push({
                    full_name: name,
                    age: age,
                });
            });


            /**
             * Fetch pickup option
             */
            let pickupOptionId = null;

            if($tourItem.find('.checkout-tour-pickup-option-select').length) {
                pickupOptionId = $tourItem.find('.checkout-tour-pickup-option-select').first().val();
            }

            /**
             * Transport booking hour tour option
             */
            let tourOptionId = null;
            let selectedTourOption = null;

            if(requestedData.tour_option !== undefined && requestedData.tour_option !== null) {
                tourOptionId = requestedData.tour_option.id;
                selectedTourOption = requestedData.tour_option;
            }

            console.log('requestData befre placeorder');
            console.log(requestedData);

            /**
             * Prepare request for booking details of the tour.
             *
             * Note that price_for_kids and price_fr+adults are required attributes in order to re-validate the data
             *
             * @type {{tour_id: (*|jQuery), date: *, price_for_adults, children: *, price_for_kids, adults: *, guests: {children: Array, adults: Array}}}
             */
            request.bookings[tourId] = {
                tour_id: tourId,
                price_for_kids: requestedData.request.price_for_kids,
                price_for_adults: requestedData.request.price_for_adults,
                children: requestedData.request.children,
                adults: requestedData.request.adults,
                startDate: requestedData.request.date,
                tour_option_id: tourOptionId,
                tour_option: selectedTourOption,
                pickup_option: pickupOptionId,
                guests: {
                    adults: adults,
                    children: children,
                }
            };

            if(!!requestedData.request.infants) {
                request.bookings[tourId]['infants'] = requestedData.request.infants;
            }

        });


        /**
         * Fill payments array
         */
        request.payment = this.handler.getPaymentRequest();

        return request;
    }
}